import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['profile', 'dropdown'];
    static classes = ['open'];

    connect() {
        this.handleOutside = this.handleOutside.bind(this);
        document.addEventListener('click', this.handleOutside);
    }

    disconnect() {
        document.removeEventListener('click', this.handleOutside);
    }

    toggleProfile(event) {
        event.stopPropagation();
        this.element.classList.toggle(this.openClass);
    }

    handleOutside(event) {
        if (this.hasProfileTarget && !this.profileTarget.contains(event.target)) {
            this.element.classList.remove(this.openClass);
        }
    }

    toggleSidebar() {
        const layout = document.querySelector('.page-layout');
        if (!layout) return;

        const isOpen = layout.classList.toggle('page-layout--sidebar-open');
        document.body.classList.toggle('no-scroll', isOpen);
    }
}
